/* global google, markers */
// import googleMapStyles from "./styles";

// $(function() {
//     if (typeof markers === "undefined") return;

//     var maxZoom = 13;

//     const map = new google.maps.Map(document.querySelector(".js-googleMap"), {
//         maxZoom: maxZoom,
//         styles: googleMapStyles,
//         disableDefaultUI: true
//     });

//     const bounds = new google.maps.LatLngBounds();
//     const mapMarker = {
//         path:
//             "M32.762,96.66h0c-.338-.473-8.368-11.749-16.38-25.164A211.038,211.038,0,0,1,5.119,50.377C1.723,42.814,0,36.887,0,32.761A32.768,32.768,0,0,1,62.945,20.009,32.565,32.565,0,0,1,65.52,32.761c0,4.127-1.722,10.054-5.118,17.616A211.1,211.1,0,0,1,49.141,71.495C41.125,84.918,33.1,96.186,32.763,96.659Zm-.379-76.355a14,14,0,1,0,9.9,4.1A13.909,13.909,0,0,0,32.383,20.305Z",
//         fillColor: "#2D4152",
//         strokeColor: "#2D4152",
//         fillOpacity: 1,
//         scale: 1,
//         stroke: 0,
//         anchor: new google.maps.Point(32.76, 96.66)
//     };

//     const marker = new google.maps.Marker({
//         position: new google.maps.LatLng(markers.lat, markers.lng),
//         map: map,
//         icon: mapMarker
//     });

//     bounds.extend(marker.position);

// ---------------------

// google.maps.event.addListener(marker, 'click', () => {
//     if (activeMarker) {
//         activeMarker.setIcon({
//             path:
//                 'M0,23.5C0,36.48,18.17,61,23.5,61S47,36.48,47,23.5a23.5,23.5,0,0,0-47,0Z',
//             fillColor: '#268ACA',
//             strokeColor: '#268ACA',
//             fillOpacity: 1,
//             scale: 1,
//             stroke: 0,
//             labelOrigin: new google.maps.Point(23.5, 26),
//             anchor: new google.maps.Point(23.5, 61),
//         });
//     }

//     marker.setIcon({
//         path:
//             'M0,23.5C0,36.48,18.17,61,23.5,61S47,36.48,47,23.5a23.5,23.5,0,0,0-47,0Z',
//         fillColor: '#344559',
//         strokeColor: '#344559',
//         fillOpacity: 1,
//         scale: 1,
//         stroke: 0,
//         labelOrigin: new google.maps.Point(23.5, 26),
//         anchor: new google.maps.Point(23.5, 61),
//     });

//     activeMarker = marker;

//     Array.from(feedItems).forEach(item =>
//         item.classList.remove('is-active')
//     );
//     item.classList.add('is-active');
//     item.scrollIntoView({ behavior: 'smooth' });
// });
// ---------------------

// map.fitBounds(bounds);
// });



// WEBPACK FOOTER //
// ../modules/Contact/assets/scripts/main.js